import React, {useEffect, useState} from 'react';
import {getInitialData, getSelfServiceReports, setReportFilter, saveToHistory, setSortConfig, setMappingReports} from './dwhSlice';
import {dwhReportManagementColumns} from './constant';
import {connect} from 'react-redux';
import GenericTable from 'app/Components/Shared/GenericTable/GenericTable';
import FilterBar from 'app/Components/Shared/GenericTable/FilterBar';

const MainDwhReportManagement = (props) => {
  const [filterChips, setFilterChips] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    initData();
    props.saveToHistory();
  }, []);

  const initData = async () => {
    await props.getInitialData();
  };

  const handleClearFilters = () => {
    setCurrentPage(1);
    onFilterChange(null, null, {});
  };

  const getSSReports = async (filterValues = null, sortConfig = null) => {
    var req = {
      ...filterValues,
      orgId: props.portalsBlock?.selectedHetPayId || '',
      businessAccountNumber: props.portalsBlock?.selectedHetPay || '',
      sortConfig: sortConfig || props.dwhReportManagement.sortConfig,
    };
    const res = await props.getSelfServiceReports(req);
  };

  const tableFilterOptions = {
    fields: [
      {
        key: 'report_scoppe',
        type: 'select',
        width: '20%',
        options: [
          {value: 'כל הפניות', key: 'All_Reports'},
          {value: 'הפניות שלי', key: 'My_reports'},
        ],
        placeholder: 'כל הפניות',
      },
      {
        key: 'mappingReports',
        type: 'selectWithCheckboxes',
        width: '40%',
        options: props.mappingReports,
        placeholder: 'סוג פעולה',
        renderChips: true,
      },
      {
        key: 'dateRange',
        type: 'dateRange',
        width: '40%',
        defaultValue: props.dwhReportManagement?.minDate,
        minDate: props.dwhReportManagement?.minDate || null,
        maxDate: new Date(),
        numOfYearsBack: 1,
      },
    ],
    showClearButton: true,
  };

  function submitSearching(filterValues) {
    const req = {
      startDate: filterValues?.startDate || '',
      endDate: filterValues?.endDate || '',
      subAreas: filterValues?.mappingReports || [],
      pageNo: filterValues?.pageNo || 1,
      reportScoppe: filterValues?.report_scoppe || '',
      orgId: props.portalsBlock?.selectedHetPayId || '',
      sortConfig: props.dwhReportManagement.sortConfig,
    };
    props.setReportFilter(req);
    getSSReports(req);
  }

  function onFilterChange(filterKey, value, currentFilterValues) {
    var newFilter = {...currentFilterValues, pageNo: 1};
    newFilter[filterKey] = value;
    newFilter.pageNo = 1;
    props.setReportFilter(newFilter);

    if (filterKey === 'mappingReports') {
      var chips = newFilter[filterKey].map((m) => ({key: m, text: props.mappingReports[m]}));
      setFilterChips(chips);
    }
  }

  function handleRemoveChip(chipId) {
    var newFilter = {...props.dwhReportManagement.reportFilter};
    newFilter['mappingReports'] = newFilter['mappingReports'].filter((m) => m !== chipId);
    setFilterChips(newFilter['mappingReports'].map((m) => ({key: m, text: props.mappingReports[m]})));

    props.setReportFilter(newFilter);
  }

  function onClearFilters() {
    var newFilter = {
      startDate: null,
      endDate: null,
      orgId: null,
      pageNo: 1,
      subAreas: [],
      report_scoppe: 'My_reports',
    };
    props.setReportFilter(newFilter);
    props.setSortConfig({});
    props.setMappingReports([]);
    setFilterChips([]);
    setCurrentPage(1);
    getSSReports(newFilter);
  }

  function onLoadMore() {
    var newFilter = {...props.dwhReportManagement.reportFilter};
    newFilter.pageNo = newFilter.pageNo + 1;
    props.setReportFilter(newFilter);
    getSSReports(newFilter);
  }

  function onSort(sortConfig) {
    props.setSortConfig(sortConfig);
    getSSReports(props.dwhReportManagement.reportFilter, sortConfig);
  }

  return (
    <div className='dwh-report-management-main'>
      {/* {!(props.error && isMobile) && (<> */}
      <div className='header'>
        <div className='l-title'>ניהול פעולות בשירות עצמי</div>
        <div className='m-title'> {props.portalsBlock.selectedOrgName} </div>
      </div>
      {props.dwhReportManagement.filterOptionsLoaded && (
        <>
          <FilterBar
            setCurrentPage={setCurrentPage}
            currentFilterValues={props.dwhReportManagement.reportFilter}
            tableFilters={tableFilterOptions}
            submitSearching={submitSearching}
            onClearFilters={() => onClearFilters()}
            onFilterChange={onFilterChange}
            chips={filterChips}
            onRemoveChip={(key) => handleRemoveChip(key)}
          />
        </>
        //  )}
        //  </>
      )}
      <GenericTable
        data={props.tableData || []}
        jsonKey='businessDetails'
        pagination={true}
        pageSize={10}
        onLoadMore={onLoadMore}
        totalRecords={props.dwhReportManagement.totalCount}
        columns={{
          tableColumns: dwhReportManagementColumns,
        }}
        sortConfig={props.dwhReportManagement.sortConfig}
        setSortConfig={(sortConfig) => onSort(sortConfig)}
        isLoading={props.dwhReportManagement.isLoading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        error={props.error}
      />
    </div>
  );
};

const mapDispatchToProps = {getInitialData, getSelfServiceReports, setReportFilter, saveToHistory, setSortConfig, setMappingReports};

const mapStateToProps = (state) => ({
  dwhReportManagement: state.dwhReportManagement,
  tableData: state.dwhReportManagement.reports,
  mappingReports: state.dwhReportManagement.mappingReports,
  portalsBlock: state.portalsBlock,
  error: state.dwhReportManagement.error,
});

export default connect(mapStateToProps, mapDispatchToProps)(MainDwhReportManagement);
